import { render, staticRenderFns } from "./CadastrarSenha.vue?vue&type=template&id=3921743e&"
import script from "./CadastrarSenha.vue?vue&type=script&lang=js&"
export * from "./CadastrarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports